var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('EsyH2',{staticClass:"header"},[_c('strong',[_vm._v("\n      "+_vm._s(_vm.agencyName)+"\n      "+_vm._s(_vm.city ?? "")+"\n    ")]),_vm._v("\n    Liefergebiet\n  ")]),_vm._v(" "),_c('PlaceList',{attrs:{"items":_vm.deliveryDistricts.slice(0, _vm.limit).map((e) => ({
        name: e,
      })),"exceeded":_vm.deliveryDistricts.length > _vm.limit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }